import { render, staticRenderFns } from "./RichTextEditor.v2.vue?vue&type=template&id=41e65143&scoped=true&"
import script from "./RichTextEditor.v2.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.v2.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditor.v2.vue?vue&type=style&index=0&id=41e65143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e65143",
  null
  
)

export default component.exports